import { SUPPORTED_LANGUAGES } from '@/common/utils/language';
import FlagIcon from './FlagIcon';
import {
	FlagWrap,
	LanguageOption,
	LanguageOptionBadge,
	LanguageOptionCopy,
	LanguageOptionDescription,
	LanguageOptionName,
	LanguageOptions,
} from '../LanguageSwitcher.styles';

const LanguageSwitcherOptionList = ({
	activeLang,
	selectLanguageLabel,
	activeLabel,
	translations,
	onSelect,
}) => (
	<LanguageOptions role="radiogroup" aria-label={selectLanguageLabel}>
		{SUPPORTED_LANGUAGES.map((item) => {
			const isActive = item.code === activeLang;

			return (
				<LanguageOption
					key={item.code}
					type="button"
					role="radio"
					aria-checked={isActive}
					$active={isActive}
					onClick={() => onSelect(item.code)}
				>
					<FlagWrap aria-hidden="true">
						<FlagIcon code={item.code} />
					</FlagWrap>
					<LanguageOptionCopy>
						<LanguageOptionName>
							{translations[item.code] ?? item.label}
						</LanguageOptionName>
						<LanguageOptionDescription>
							{translations[`${item.code}Description`] ?? item.label}
						</LanguageOptionDescription>
					</LanguageOptionCopy>
					{isActive && <LanguageOptionBadge>{activeLabel}</LanguageOptionBadge>}
				</LanguageOption>
			);
		})}
	</LanguageOptions>
);

export default LanguageSwitcherOptionList;
